/**
 * Joins the provided class-name parts into a single string, dropping any
 * falsy values (`undefined`/`false`/`""`). Shared across the CLE design-system
 * components so the helper isn't redefined per file.
 */
export const mergeClass = (...parts: (string | undefined | false)[]): string =>
  parts.filter(Boolean).join(" ").trim();

export default mergeClass;
